import React, { useState } from 'react';
import { 
    LayoutDashboard, 
    Users, 
    FileText, 
    AlertTriangle, 
    Users2,
    ShoppingBag,
    GraduationCap,
    Calendar,
    MessageCircle,
    Settings,
    Bell,
} from 'lucide-react';

const useMenuItems = () => {
    const [showValidationModal, setShowValidationModal] = useState(false);

    // Menu items pour l'administration FONAP
    const menuItems = [
        {
            label: 'Tableau de bord',
            path: '/dashboard',
            icon: <LayoutDashboard />,
            description: 'Vue d\'ensemble des statistiques'
        },
        {
            isDivider: true,
            label: 'Gestion du contenu'
        },
        {
            label: 'Publications',
            path: '/publications',
            icon: <FileText />,
            description: 'Toutes les publications'
        },
        {
            label: 'Signalements',
            path: '/reports',
            icon: <AlertTriangle />,
            description: 'Modération des signalements'
        },
        {
            isDivider: true,
            label: 'Services & Activités'
        },
        {
            label: 'Formations',
            path: '/formations',
            icon: <GraduationCap />,
            description: 'Gestion des formations'
        },
        {
            label: 'Événements',
            path: '/events',
            icon: <Calendar />,
            description: 'Gestion des événements'
        },
        {
            label: 'Produits & Services',
            path: '/products',
            icon: <ShoppingBag />,
            description: 'Marketplace'
        },
        {
            label: 'Messagerie',
            path: '/chat',
            icon: <MessageCircle />,
            description: 'Supervision des messages'
        },
        {
            isDivider: true,
            label: 'Gestion des utilisateurs'
        },
        {
            label: 'Utilisateurs',
            path: '/users',
            icon: <Users />,
            description: 'Gestion des comptes utilisateurs'
        },
        {
            label: 'Groupes',
            path: '/groups',
            icon: <Users2 />,
            description: 'Gestion des groupes'
        },
       
        {
            isDivider: true,
            label: 'Administration système'
        },
       
        {
            label: 'Notifications',
            path: '/notifications',
            icon: <Bell />,
            description: 'Notifications système'
        },
        {
            label: 'Paramètres',
            path: '/settings',
            icon: <Settings />,
            description: 'Configuration système'
        },
    ];

    return {
        menuItems,
        showValidationModal,
        setShowValidationModal
    };
};

export default useMenuItems;